export enum EventNames {
  GENERAL = 'general',
  TRACKING = 'tracking',
}
